import { z } from 'zod';
import { listRecommendedQuestsOutputSchema } from '@zealy/schemas/src/quest';
import { query } from '../../utils';
export const listRecommendedQuests = query({
    method: 'GET',
    path: '/recommended',
    query: z.object({
        page: z.coerce.number().min(0).default(0),
        limit: z.coerce.number().min(1).max(100).default(10),
    }),
    responses: {
        200: listRecommendedQuestsOutputSchema,
    },
});
